<template>
  <Base
    ref="base"
    :on-submit="(params) => reportsService.createFormTemplate(params)"
    :on-get="(id) => reportsService.getTemplateById(id)"
    :triger-prevent="trigerPrevent"
    field-details-route="field-details"
    templates-route="templates"
  />
</template>

<script>
import { mapActions } from 'vuex';

import Base from '../base/base-edit';
import { ReportsMixin } from '../../../../../mixins';

import { beforeRouteLeaveFunction } from '../base/common';

export default {
  title: 'CopyCaseTemplate',
  components: { Base },
  mixins: [ReportsMixin],
  beforeRouteLeave(to, from, next) {
    const changed = this.$refs.base.exit();
    return beforeRouteLeaveFunction(to, from, next, this.disablePrevent, this.$translate, changed, this.clearTemplates);
  },
  data() {
    return {
      disablePrevent: false,
    };
  },
  ...mapActions({ clearTemplates: 'template/clearTemplates' }),
  methods: {
    trigerPrevent: function (value) {
      this.disablePrevent = value;
    },
  },
};
</script>
